import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Btn } from "@/components/Btn";

const STEPS = [
  { no: "01", title: "Choose", copy: "Choose the package that's right for you and start immediately. No quotes, no waiting for a proposal." },
  { no: "02", title: "Tell us", copy: "Complete a short, guided project brief so we understand your business, your goals and what you already have." },
  { no: "03", title: "Create", copy: "We design and build your website. You're kept updated throughout — this is where the craft happens." },
  { no: "04", title: "Review", copy: "You review your website in a private preview and we refine the details together, as agreed." },
  { no: "05", title: "Launch", copy: "We handle domain connection, email, security and setup, then launch your site to the world." },
];

export default function Process() {
  return (
    <>
      <PageHero eyebrow="Process" title="Easy to buy." accent="Personally supported."
        subtitle="Buying directly doesn't mean you're on your own. From the moment you order, your project is professionally managed and personally supported." />
      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-24">
          {STEPS.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.04}>
              <div data-testid={`process-step-${s.no}`} className="grid grid-cols-1 gap-6 border-t border-ink/12 py-12 md:grid-cols-12 md:items-center md:py-16">
                <span className="font-serif text-6xl text-champagne md:col-span-2">{s.no}</span>
                <h2 className="font-serif text-3xl tracking-tight md:col-span-4 md:text-4xl">{s.title}</h2>
                <p className="text-lg leading-relaxed text-ink/70 md:col-span-5 md:col-start-8">{s.copy}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-ink/12 py-16 text-center">
            <p className="mx-auto max-w-2xl font-serif text-2xl leading-snug md:text-3xl">After payment, we'll guide you through collecting content and assets — you're never left wondering what happens next.</p>
            <div className="mt-8 flex justify-center"><Btn to="/start" variant="primary" testid="process-start">Start my Project</Btn></div>
          </div>
        </div>
      </section>
    </>
  );
}
